var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashVectorGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 1.33333H8.91663L8.08329 0.5H3.91663L3.08329 1.33333H0.166626V3H11.8333V1.33333ZM0.999959 13.8333C0.999959 14.2754 1.17555 14.6993 1.48811 15.0118C1.80068 15.3244 2.2246 15.5 2.66663 15.5H9.33329C9.77532 15.5 10.1992 15.3244 10.5118 15.0118C10.8244 14.6993 11 14.2754 11 13.8333V3.83333H0.999959V13.8333Z",
    fill: "#9AA2B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashVectorGrey);
export default __webpack_public_path__ + "static/media/trashVectorGrey.0065b3812a096488788e3411bfd54a66.svg";
export { ForwardRef as ReactComponent };